@if (this.forms && this.forms.length) {
  <div class="pinned">
    <h1 class="title">{{ (intakeMode === 'edit' ? 'intake.form.edit_title' : intakeMode === 'create' ? 'intake.form.create_title' : 'vacancy.new_vacancy') | translate }}</h1>
    <div class="buttons">
      <button nbButton shape="semi-round" size="small" status="basic" (click)="close()">{{ 'cancel' | translate }}</button>
    </div>
  </div>

  @if (!createdVacancy) {
    <article class="card-like no-right-padding">
      <nb-stepper orientation="vertical" #stepper>
        <!-- Step 1: Basic info -->
        <nb-step [stepControl]="this.forms[0].form" [label]="'vacancy.name' | translate">
          <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
            <h2>{{ 'vacancy.name_question' | translate }}</h2>
            <form [formGroup]="this.forms[0].form" class="step-container">
              <div class="input-group">
                <input nbInput fullWidth required fieldSize="large" type="text" maxLength="255" nbAutofocus
                  [placeholder]="'vacancy.enter_name' | translate" formControlName="title">
              </div>
              <div class="input-group">
                <ul class="field-list">
                  @if (!intakeMode) {
                    <li>
                      <label><nb-icon icon="link-2-outline"></nb-icon><span>{{ 'vacancy.source' | translate }}</span></label>
                      <input nbInput fullWidth formControlName="source" fieldSize="small"
                        [placeholder]="'vacancy.source' | translate"
                        [nbAutocomplete]="sourceAutocomplete">
                      <nb-autocomplete #sourceAutocomplete>
                        @for (source of availableSources; track source) {
                          <nb-option [value]="source">{{ source }}</nb-option>
                        }
                      </nb-autocomplete>
                    </li>
                  }
                  <li class="description-field">
                    <label><nb-icon icon="info-outline"></nb-icon><span>{{ 'description' | translate }}</span></label>
                    <textarea nbInput formControlName="description"
                      [placeholder]="'vacancy.enter_description' | translate"
                      maxlength="30000"></textarea>
                    @if (!intakeMode) {
                      <div class="ai-fill-section">
                        <div class="ai-fill-header">
                          <button nbButton size="small" type="button"
                            status="info"
                            [disabled]="filling || !this.forms[0].form.get('description')?.value"
                            [nbTooltip]="'vacancy.fillwithai.tooltip' | translate"
                            [class.loading]="filling"
                            (click)="fillWithAI()">
                            @if (!filling) {
                              <nb-icon icon="bulb-outline"></nb-icon>
                            }
                            @if (filling) {
                              <nb-spinner size="tiny" status="control"></nb-spinner>
                            }
                            {{ (filling ? 'vacancy.fillwithai.loading' : 'vacancy.fillwithai.label') | translate }}
                          </button>
                        </div>
                        <div class="ai-privacy-toggle" (click)="privacyExpanded = !privacyExpanded">
                          <nb-icon icon="shield-outline"></nb-icon>
                          <span>{{ 'vacancy.fillwithai.privacy.toggle' | translate }}</span>
                          <nb-icon [icon]="privacyExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
                        </div>
                        @if (privacyExpanded) {
                          <div class="ai-privacy-details">
                            <div class="privacy-section">
                              <strong>{{ 'vacancy.fillwithai.privacy.what_title' | translate }}</strong>
                              <p>{{ 'vacancy.fillwithai.privacy.what_text' | translate }}</p>
                            </div>
                            <div class="privacy-section">
                              <strong>{{ 'vacancy.fillwithai.privacy.how_title' | translate }}</strong>
                              <p>{{ 'vacancy.fillwithai.privacy.how_text' | translate }}</p>
                            </div>
                            <div class="privacy-section">
                              <strong>{{ 'vacancy.fillwithai.privacy.who_title' | translate }}</strong>
                              <p>{{ 'vacancy.fillwithai.privacy.who_text' | translate }}</p>
                            </div>
                            <div class="privacy-section">
                              <strong>{{ 'vacancy.fillwithai.privacy.retention_title' | translate }}</strong>
                              <p>{{ 'vacancy.fillwithai.privacy.retention_text' | translate }}</p>
                            </div>
                            <div class="privacy-section">
                              <strong>{{ 'vacancy.fillwithai.privacy.rights_title' | translate }}</strong>
                              <p>{{ 'vacancy.fillwithai.privacy.rights_text' | translate }}</p>
                            </div>
                            <div class="privacy-section">
                              <strong>{{ 'vacancy.fillwithai.privacy.transparency_title' | translate }}</strong>
                              <p>{{ 'vacancy.fillwithai.privacy.transparency_text' | translate }}</p>
                            </div>
                            <div class="privacy-footer">
                              <a href="assets/files/flix_it_privacy_policy.pdf" target="_blank">{{ 'vacancy.fillwithai.privacy.full_policy' | translate }}</a>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </li>
                  <li>
                    <label><nb-icon icon="briefcase-outline"></nb-icon><span>{{ 'company' | translate }}</span></label>
                    <input nbInput fullWidth formControlName="company" fieldSize="small">
                  </li>
                  <li>
                    <label><nb-icon icon="pin-outline"></nb-icon><span>{{ 'location' | translate }}</span></label>
                    <input nbInput fullWidth formControlName="location" fieldSize="small">
                  </li>
                  @if (!intakeMode) {
                    <li>
                      <label><nb-icon icon="external-link-outline"></nb-icon><span>URL</span></label>
                      <input nbInput fullWidth formControlName="url" fieldSize="small" placeholder="https://">
                    </li>
                  }
                </ul>
              </div>
              <button nbButton [bstErroring]="this.forms[0].form" (bstErroringSuccess)="stepper.next()" type="button" status="primary">{{ 'next' | translate }}<nb-icon icon="chevron-right"></nb-icon></button>
            </form>
          </div>
        </nb-step>

        <!-- Step 2: Timeline -->
        <nb-step [stepControl]="this.forms[1].form" [label]="'projecttimeline' | translate">
          <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
            <h2>{{ 'vacancy.timeline_question' | translate }}</h2>
            <form [formGroup]="this.forms[1].form" class="step-container">
              <div class="input-group">
                <ul class="field-list">
                  <li>
                    <label><nb-icon icon="calendar-outline"></nb-icon><span>{{ 'startdate' | translate }}</span></label>
                    <input nbInput fieldSize="small" [nbDatepicker]="startPicker" formControlName="start_date">
                    <nb-datepicker #startPicker [format]="intakeMode ? 'DD-MM-YYYY' : null"></nb-datepicker>
                  </li>
                  @if (!intakeMode) {
                    <li>
                      <label><nb-icon icon="calendar-outline"></nb-icon><span>{{ 'enddate' | translate }}</span></label>
                      <input nbInput fieldSize="small" [nbDatepicker]="endPicker" formControlName="end_date">
                      <nb-datepicker #endPicker [format]="intakeMode ? 'DD-MM-YYYY' : null"></nb-datepicker>
                    </li>
                  }
                  <li>
                    <label><nb-icon icon="alert-circle-outline"></nb-icon><span>{{ 'Deadline' | translate }}</span></label>
                    <input nbInput fieldSize="small" [nbDatepicker]="deadlinePicker" formControlName="deadline">
                    <nb-datepicker #deadlinePicker [format]="intakeMode ? 'DD-MM-YYYY' : null"></nb-datepicker>
                  </li>
                  <li>
                    <label><nb-icon icon="clock-outline"></nb-icon><span>{{ 'vacancy.hoursperweek' | translate }}</span></label>
                    <input nbInput fullWidth formControlName="hours_per_week" fieldSize="small">
                  </li>
                  <li>
                    <label><nb-icon icon="pricetags-outline"></nb-icon><span>{{ 'vacancy.tariff' | translate }}</span></label>
                    <input nbInput fullWidth formControlName="tariff" fieldSize="small">
                  </li>
                  @if (!intakeMode) {
                    <li>
                      <label><nb-icon icon="trending-up-outline"></nb-icon><span>{{ 'vacancy.years_experience' | translate }}</span></label>
                      <input nbInput fullWidth formControlName="years_experience" fieldSize="small">
                    </li>
                  }
                </ul>
              </div>
              <button nbButton nbStepperPrevious type="button"><nb-icon icon="chevron-left"></nb-icon>{{ 'previous' | translate }}</button>
              @if (intakeMode) {
                <button nbButton (click)="submit()" [disabled]="submitting || intakeInvalid" status="primary" type="button"><nb-icon icon="checkmark"></nb-icon><span>{{ 'save' | translate }}</span></button>
                @if (errorMessage) {
                  <p class="intake-error" role="alert">{{ errorMessage }}</p>
                }
              } @else {
                <button nbButton (click)="stepper.next()" status="primary" type="button">{{ 'next' | translate }}<nb-icon icon="chevron-right"></nb-icon></button>
              }
            </form>
          </div>
        </nb-step>

        <!-- Step 3: Hard Skills -->
        @if (!intakeMode) {
          <nb-step [label]="'hardskills' | translate">
            <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
              <h2>{{ 'vacancy.what_skills' | translate }}</h2>
              <form [formGroup]="this.forms[2].form" class="step-container">
                <div class="input-group">
                  <bst-list-adder size="large" [autolist]="true" target="skill" [placeholder]="'search?' | translate" formControlName="skills"></bst-list-adder>
                </div>
                <button nbButton nbStepperPrevious type="button"><nb-icon icon="chevron-left"></nb-icon>{{ 'previous' | translate }}</button>
                <button nbButton (click)="stepper.next()" status="primary" type="button">{{ 'next' | translate }}<nb-icon icon="chevron-right"></nb-icon></button>
              </form>
            </div>
          </nb-step>
        }
        <!-- Step 4: Soft Skills -->
        @if (!intakeMode) {
          <nb-step [label]="'softskills' | translate">
            <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
              <h2>{{ 'vacancy.what_soft_skills' | translate }}</h2>
              <form [formGroup]="this.forms[3].form" class="step-container">
                <div class="input-group">
                  <bst-list-adder size="large" [autolist]="true" target="development" [placeholder]="'search?' | translate" formControlName="developments"></bst-list-adder>
                </div>
                <button nbButton nbStepperPrevious type="button"><nb-icon icon="chevron-left"></nb-icon>{{ 'previous' | translate }}</button>
                <button nbButton (click)="stepper.next()" status="primary" type="button">{{ 'next' | translate }}<nb-icon icon="chevron-right"></nb-icon></button>
              </form>
            </div>
          </nb-step>
        }
        <!-- Step 5: Certifications -->
        @if (!intakeMode) {
          <nb-step [label]="'certifications' | translate">
            <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
              <h2>{{ 'vacancy.what_certifications' | translate }}</h2>
              <form [formGroup]="this.forms[4].form" class="step-container">
                <div class="input-group">
                  <bst-list-adder size="large" [autolist]="true" target="certification" [placeholder]="'search?' | translate" formControlName="certifications"></bst-list-adder>
                </div>
                <button nbButton nbStepperPrevious type="button"><nb-icon icon="chevron-left"></nb-icon>{{ 'previous' | translate }}</button>
                <button nbButton (click)="stepper.next()" status="primary" type="button">{{ 'next' | translate }}<nb-icon icon="chevron-right"></nb-icon></button>
              </form>
            </div>
          </nb-step>
        }
        <!-- Step 6: Industries + Submit -->
        @if (!intakeMode) {
          <nb-step [label]="'industries' | translate">
            <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
              <h2>{{ 'vacancy.what_industry' | translate }}</h2>
              <form [formGroup]="this.forms[5].form" class="step-container">
                <div class="input-group">
                  <bst-list-adder size="large" [autolist]="true" target="industry" [placeholder]="'search?' | translate" formControlName="industries"></bst-list-adder>
                </div>
                <button nbButton nbStepperPrevious type="button"><nb-icon icon="chevron-left"></nb-icon>{{ 'previous' | translate }}</button>
                <button nbButton (click)="submit()" [disabled]="submitting" status="primary" type="button"><nb-icon icon="checkmark"></nb-icon><span>{{ 'save' | translate }}</span></button>
              </form>
            </div>
          </nb-step>
        }
      </nb-stepper>
    </article>
  }

  @if (createdVacancy && !intakeMode) {
    <article class="card-like">
      <div class="success-state">
        <nb-icon icon="checkmark-circle-2-outline" status="success"></nb-icon>
        <h2>{{ createdVacancy.title }}</h2>
        <p>{{ 'vacancy.created' | translate }}</p>

        <div class="action-buttons">
          <button nbButton status="primary" size="small" (click)="viewCreated()">
            <nb-icon icon="eye-outline"></nb-icon> {{ 'view' | translate }}
          </button>
          <button nbButton status="basic" size="small" (click)="close()">
            {{ 'vacancy.back_to_overview' | translate }}
          </button>
        </div>
      </div>
    </article>
  }
}
